import { Loader2 } from 'lucide-react';

export const AppLoader = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Loading your workspace...</p>
      </div>
    </div>
  );
};